import {Alert} from "@mui/material";
import {FetchBaseQueryError} from "@reduxjs/toolkit/query";
import {SerializedError} from "@reduxjs/toolkit";

export interface QueryErrorAlertProps {
    error: FetchBaseQueryError | SerializedError | undefined;
}

export default function QueryErrorAlert({error}: QueryErrorAlertProps) {
    if (!error) {
        return null;
    }

    return isFetchBaseQueryError(error) ? (
        <Alert severity="error">
            {error.status} {JSON.stringify(error.data)}
        </Alert>
    ) : (
        <Alert severity="error">{error.message}</Alert>
    );
}

function isFetchBaseQueryError(error: FetchBaseQueryError | SerializedError): error is FetchBaseQueryError {
    return (error as FetchBaseQueryError).status !== undefined && (error as FetchBaseQueryError).data !== undefined;
}
